'use strict';

/**
 * @ngdoc service
 * @name courseApp.API
 * @description
 * # API
 * Create the factorys in the courseApp for API access.
 */

angular.module('courseApp')
    .factory('CourseService', function ($resource, CONFIG) {
        return $resource(
            CONFIG.apiURL + 'course/:id/', { id: '@id' }
            // Creates a PUT method defined as 'update'
            , {
                update: {
                    method: 'PUT',
                    params: { id: '@id' }
                }
            }
        );
    });

angular.module('courseApp')
    .factory('AttendeeService', function ($resource, CONFIG) {
        return $resource(
            CONFIG.apiURL + 'courseattendee/:id/', { id: '@id' }
            // Creates a PUT method defined as 'update'
            , {
                update: {
                    method: 'PUT',
                    params: { id: '@id' }
                }
            }
        );
    });

angular.module('courseApp')
    .factory('LSVService', function ($resource, CONFIG) {
        return $resource(
            CONFIG.apiURL + 'lsv/:id/', { id: '@id' }
            // Creates a PUT method defined as 'update'
            , {
                update: {
                    method: 'PUT',
                    params: { id: '@id' }
                }
            }
        );
    });

angular.module('courseApp')
    .factory('CourseHotelService', function ($resource, CONFIG) {
        return $resource(
            CONFIG.apiURL + 'coursehotel/:id/', { id: '@id' }
            // Creates a PUT method defined as 'update'
            , {
                update: {
                    method: 'PUT',
                    params: { id: '@id' }
                }
            }
        );
    });

angular.module('courseApp')
    .factory('HotelRoomService', function ($resource, CONFIG) {
        return $resource(
            CONFIG.apiURL + 'hotel_room/:id/', { id: '@id' }
            // Creates a PUT method defined as 'update'
            , {
                update: {
                    method: 'PUT',
                    params: { id: '@id' }
                }
            }
        );
    });

angular.module('courseApp')
    .factory('HotelRoomAttendeesService', function ($resource, CONFIG) {
        return $resource(
            CONFIG.apiURL + 'hotel_room_attendees/:id/', { id: '@id' }
            // Creates a PUT method defined as 'update'
            , {
                update: {
                    method: 'PUT',
                    params: { id: '@id' }
                }
            }
        );
    });

angular.module('courseApp')
    .factory('GroupService', function ($resource, CONFIG) {
        return $resource(
            CONFIG.apiURL + 'group/:id/', { id: '@id' }
            // Creates a PUT method defined as 'update'
            , {
                update: {
                    method: 'PUT',
                    params: { id: '@id' }
                }
            }
        );
    });

angular.module('courseApp')
    .factory('GroupAttendeeService', function ($resource, CONFIG) {
        return $resource(
            CONFIG.apiURL + 'group_attendee/:id/', { id: '@id' }
            // Creates a PUT method defined as 'update'
            , {
                update: {
                    method: 'PUT',
                    params: { id: '@id' }
                }
            }
        );
    });

angular.module('courseApp')
    .service('APIGroup', function (GroupService, GroupAttendeeService) {
        return {
            GroupService: GroupService,
            GroupAttendeeService: GroupAttendeeService
        };
    });

angular.module('courseApp')
    .service('APIHotel', function (HotelRoomService, HotelRoomAttendeesService) {
        return {
            HotelRoomService: HotelRoomService,
            HotelRoomAttendeesService: HotelRoomAttendeesService
        };
    });

angular.module('courseApp')
    .service('APICourse', function (CourseService, CourseHotelService) {
        return {
            CourseService: CourseService,
            CourseHotelService: CourseHotelService
        };
    });

angular.module('courseApp')
    .service('APIs', function (APICourse, APIHotel, AttendeeService, APIGroup, LSVService) {
        return {
            CourseService: APICourse.CourseService,
            AttendeeService: AttendeeService,
            LSVService: LSVService,
            GroupService: APIGroup.GroupService,
            GroupAttendeeService: APIGroup.GroupAttendeeService,
            CourseHotelService: APICourse.CourseHotelService,
            HotelRoomService: APIHotel.HotelRoomService,
            HotelRoomAttendeesService: APIHotel.HotelRoomAttendeesService
        };
    });
